module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_9016.66a1ccf5.png";